import Vue from "vue";
import Router from "vue-router";
import utils from "@/utils";
Vue.use(Router);

const router = new Router({
    // mode: "history",
    routes: [{
            path: "/",
            name: "home",
            component: () =>
                import ("@/page/home/index.vue")
        },
        {
            path: "/login",
            name: "login",
            component: () =>
                import ("@/page/login/index.vue")
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (!utils.is_qyweixin()) {
        // 外部浏览器
        if (to.name == "home" && utils.getSearchParams("state") != "qr_state") {
            window.localStorage.removeItem("qyvx_email");
            next({ name: "login" });
        } else {
            next();
        }
    } else if(utils.getSearchParams("url") != null && utils.getSearchParams("ssoappid") != null) {  //此次请求为跳转 URL
        window.localStorage.setItem("ssoappid", utils.getSearchParams("ssoappid"));
        window.localStorage.setItem("jump_url2", utils.getSearchParams("url"));
        window.location.href = "/login?ssoappid=" + utils.getSearchParams("ssoappid") + "&jump_url2=" + utils.getSearchParams("url");
    } else {
        next();
    }
});

export default router;